'use strict';exports.__esModule = true;var _victory = require('./victory.png');var _victory2 = _interopRequireDefault(_victory);
var _theRightWay = require('./the-right-way.png');var _theRightWay2 = _interopRequireDefault(_theRightWay);
var _stockbroker = require('./stockbroker.png');var _stockbroker2 = _interopRequireDefault(_stockbroker);
var _samariaRealEstate = require('./samaria-real-estate.png');var _samariaRealEstate2 = _interopRequireDefault(_samariaRealEstate);
var _requires = require('./requires.png');var _requires2 = _interopRequireDefault(_requires);
var _replace = require('./replace.png');var _replace2 = _interopRequireDefault(_replace);
var _remax = require('./remax.png');var _remax2 = _interopRequireDefault(_remax);
var _reich = require('./reich.png');var _reich2 = _interopRequireDefault(_reich);
var _realeStateDolutions = require('./reale-state-dolutions.png');var _realeStateDolutions2 = _interopRequireDefault(_realeStateDolutions);
var _realEstateWell = require('./real-estate-well.png');var _realEstateWell2 = _interopRequireDefault(_realEstateWell);
var _realEstateSolutions = require('./real-estate-solutions.png');var _realEstateSolutions2 = _interopRequireDefault(_realEstateSolutions);
var _quickRealEstate = require('./quick-real-estate.png');var _quickRealEstate2 = _interopRequireDefault(_quickRealEstate);
var _provence = require('./provence.png');var _provence2 = _interopRequireDefault(_provence);
var _maxHome = require('./max-home.png');var _maxHome2 = _interopRequireDefault(_maxHome);
var _homeland = require('./homeland.png');var _homeland2 = _interopRequireDefault(_homeland);
var _homeInIsrael = require('./home-in-Israel.png');var _homeInIsrael2 = _interopRequireDefault(_homeInIsrael);
var _hmInvest = require('./hm-invest.png');var _hmInvest2 = _interopRequireDefault(_hmInvest);
var _govAri = require('./gov-ari.png');var _govAri2 = _interopRequireDefault(_govAri);
var _goldmanRealEstate = require('./goldman-real-estate.png');var _goldmanRealEstate2 = _interopRequireDefault(_goldmanRealEstate);
var _goReality = require('./go-reality.png');var _goReality2 = _interopRequireDefault(_goReality);
var _friendshipFoundation = require('./friendship-foundation.png');var _friendshipFoundation2 = _interopRequireDefault(_friendshipFoundation);
var _franzi = require('./franzi.png');var _franzi2 = _interopRequireDefault(_franzi);
var _fiveRealEstateConsultants = require('./five-real-estate-consultants.png');var _fiveRealEstateConsultants2 = _interopRequireDefault(_fiveRealEstateConsultants);
var _firstRealEstate = require('./first-real-estate.png');var _firstRealEstate2 = _interopRequireDefault(_firstRealEstate);
var _eranDrori = require('./eran-drori.png');var _eranDrori2 = _interopRequireDefault(_eranDrori);
var _elios = require('./elios.png');var _elios2 = _interopRequireDefault(_elios);
var _claireWilliams = require('./claire-williams.png');var _claireWilliams2 = _interopRequireDefault(_claireWilliams);
var _apartmentsFirst = require('./apartments-first.png');var _apartmentsFirst2 = _interopRequireDefault(_apartmentsFirst);
var _angloSaxon = require('./anglo-saxon.png');var _angloSaxon2 = _interopRequireDefault(_angloSaxon);
var _Group = require('./7Group.png');var _Group2 = _interopRequireDefault(_Group);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
    victory: _victory2.default,
    theRightWay: _theRightWay2.default,
    stockbroker: _stockbroker2.default,
    samariaRealEstate: _samariaRealEstate2.default,
    requires: _requires2.default,
    replace: _replace2.default,
    remax: _remax2.default,
    reich: _reich2.default,
    realeStateDolutions: _realeStateDolutions2.default,
    realEstateWell: _realEstateWell2.default,
    realEstateSolutions: _realEstateSolutions2.default,
    quickRealEstate: _quickRealEstate2.default,
    provence: _provence2.default,
    maxHome: _maxHome2.default,
    homeland: _homeland2.default,
    homeInIsrael: _homeInIsrael2.default,
    hmInvest: _hmInvest2.default,
    govAri: _govAri2.default,
    goldmanRealEstate: _goldmanRealEstate2.default,
    goReality: _goReality2.default,
    friendshipFoundation: _friendshipFoundation2.default,
    franzi: _franzi2.default,
    fiveRealEstateConsultants: _fiveRealEstateConsultants2.default,
    firstRealEstate: _firstRealEstate2.default,
    eranDrori: _eranDrori2.default,
    elios: _elios2.default,
    claireWilliams: _claireWilliams2.default,
    apartmentsFirst: _apartmentsFirst2.default,
    angloSaxon: _angloSaxon2.default,
    group: _Group2.default };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./static/images/RealtorLanding/RealtorsLogos/index.js
// module id = 3169
// module chunks = 0